import { useMemo } from "react";
import useAuth from "./useAuth";
import { useProject } from "src/contexts/project";
import { isOnsiteCaptureProject } from "../components/modals/ProjectActions/projectReceivingWorkflow";
import {
  getDestinationInfo,
  electricalInfo,
  getDescriptiveInfo,
  getIdentifiers,
  getMechanicalInfo,
  getOriginInfo,
  getWarehouseInfo,
  plumbingInfo,
} from "../constants/fields";

export default function useAllFields(project) {
  const { user } = useAuth();
  const contextProject = useProject();
  const { settings } = user.company;
  const resolvedProject = project === undefined ? contextProject : project;
  const onsiteCaptureMode = isOnsiteCaptureProject(resolvedProject);
  const fieldValues = useMemo(
    () => ({ ...settings, onsiteCaptureMode }),
    [settings, onsiteCaptureMode]
  );

  return useMemo(
    () => ({
      identifiers: getIdentifiers(fieldValues),
      descriptiveInfo: getDescriptiveInfo(fieldValues),
      warehouseInfo: getWarehouseInfo({ availableQuantity: settings.quantity_label }),
      originInfo: getOriginInfo(settings),
      destinationInfo: getDestinationInfo(settings),
      electricalInfo,
      plumbingInfo,
      mechanicalInfo: getMechanicalInfo(settings),
    }),
    [fieldValues, settings]
  );
}
